var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "interaction-rightbar mb-2 py-3"
  }, [_c('div', [_c('div', {
    staticClass: "mb-0 px-3"
  }, [_c('h5', {
    staticClass: "mb-1",
    staticStyle: {
      "color": "#536c79"
    }
  }, [_vm._v("User Info")]), (_vm.userInfo) ? _c('div', [(_vm.userInfo.status) ? _c('div', [_c('span', [_c('i', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.onlineStatus))])]), _c('div', {
    staticClass: "avatar",
    staticStyle: {
      "width": "14px",
      "top": "1px"
    }
  }, [_c('span', {
    staticClass: "avatar-status",
    class: _vm.userInfo ? "bg-" + _vm.userInfo.status : "bg-danger"
  })]), _c('br')]) : _vm._e(), (_vm.name) ? _c('div', [_vm._v("Name: " + _vm._s(_vm.name))]) : _vm._e(), (_vm.preferredName) ? _c('div', [_vm._v("Preferred Name: " + _vm._s(_vm.preferredName))]) : _vm._e(), (_vm.email) ? _c('div', [_vm._v("Email: " + _vm._s(_vm.email || _vm.userEmail))]) : _vm._e(), (_vm.userLineNumber) ? _c('div', [_vm._v("giga Number: " + _vm._s(_vm.userLineNumber))]) : _vm._e(), (_vm.osUserId) ? _c('div', [_vm._v("OutSystems User ID: " + _vm._s(_vm.osUserId))]) : _vm._e(), (_vm.mtxUserId) ? _c('div', [_vm._v("Matrixx User ID: " + _vm._s(_vm.mtxUserId))]) : _vm._e()]) : _vm._e()]), _c('hr')]), (_vm.uploadedPics.length) ? _c('div', [_vm._m(0), _c('hr')]) : _vm._e(), _c('div', [_c('div', {
    staticClass: "mb-0 px-3"
  }, [_c('h5', {
    staticClass: "mb-1",
    staticStyle: {
      "color": "#536c79"
    }
  }, [_vm._v("CRM Info")]), (_vm.userInfo) ? _c('div', [(_vm.CRMname) ? _c('div', [_vm._v("Name: " + _vm._s(_vm.CRMname))]) : _vm._e(), (_vm.CRMemail) ? _c('div', [_vm._v("Email: " + _vm._s(_vm.CRMemail))]) : _vm._e()]) : _vm._e()]), _c('hr')]), _c('div', [_c('div', {
    staticClass: "mb-0 px-3"
  }, [_c('span', {
    staticClass: "add-note-button",
    on: {
      "click": _vm.addNoteClickHandler
    }
  }, [_vm._v("Add Note")]), _c('h5', {
    staticClass: "mb-3",
    staticStyle: {
      "color": "#536c79"
    }
  }, [_vm._v("Notes")]), (_vm.displayAddNoteTextarea) ? _c('b-form-textarea', {
    ref: "note-input",
    staticClass: "mb-1",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "rows": 3,
      "max-rows": 6,
      "placeholder": "Jot down something..."
    },
    nativeOn: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleEnter($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.hideAddNoteTextarea($event)
      }]
    },
    model: {
      value: (_vm.addNoteText),
      callback: function($$v) {
        _vm.addNoteText = $$v
      },
      expression: "addNoteText"
    }
  }) : _vm._e(), (_vm.notes.length == 0 && !_vm.displayAddNoteTextarea) ? _c('div', [_c('i', {
    staticClass: "text-muted"
  }, [_vm._v("No notes available")])]) : _vm._l((_vm.notesReversed), function(note, index) {
    return _c('div', {
      staticClass: "note"
    }, [_c('div', {
      staticClass: "note-text",
      domProps: {
        "innerHTML": _vm._s(_vm.replaceNewlineToBr(note.text))
      }
    }), _c('div', {
      staticClass: "note-others"
    }, [_c('span', [_vm._v(_vm._s(_vm.formatTimeAgo(note.timestamp)))]), _c('span', [_vm._v(" · ")]), _c('span', {
      staticClass: "delete-note-button",
      on: {
        "click": function($event) {
          _vm.deleteNote(note.id)
        }
      }
    }, [_vm._v("Delete")])]), (index != _vm.notes.length - 1) ? _c('hr') : _vm._e()])
  })], 2), _c('hr')]), _c('div', {
    staticStyle: {
      "position": "absolute",
      "bottom": "40px",
      "text-align": "center",
      "width": "100%",
      "margin": "5px"
    }
  }, [_c('div', {
    staticClass: "mb-2 px-3"
  }, [_c('b-button', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        _vm.showPropt = true
      }
    }
  }, [_vm._v("Create New Service Request")])], 1)]), _c('b-modal', {
    attrs: {
      "title": "Create New Service Request"
    },
    model: {
      value: (_vm.showPropt),
      callback: function($$v) {
        _vm.showPropt = $$v
      },
      expression: "showPropt"
    }
  }, [_c('b-form', {
    attrs: {
      "id": "complainForm"
    },
    on: {
      "submit": _vm.checkForm
    }
  }, [(_vm.errors.length) ? _c('span', [_vm._v("Please correct the following error(s):"), _c('ul', _vm._l((_vm.errors), function(error) {
    return _c('li', [_vm._v(_vm._s(error))])
  }))]) : _vm._e(), _c('span', [_vm._v("Mobile Number")]), _c('b-input', {
    attrs: {
      "id": "mobileNumber",
      "type": "text",
      "name": "mobileNumber",
      "placeholder": "Enter Mobile Number"
    },
    model: {
      value: (_vm.mobileNumber),
      callback: function($$v) {
        _vm.mobileNumber = $$v
      },
      expression: "mobileNumber"
    }
  }), _c('span', [_vm._v("Request Type")]), _c('b-form-select', {
    attrs: {
      "id": "requestType",
      "name": "requestType",
      "placeholder": "Select Request Type",
      "options": _vm.requestTypeOptions
    },
    model: {
      value: (_vm.requestType),
      callback: function($$v) {
        _vm.requestType = $$v
      },
      expression: "requestType"
    }
  }, [_c('template', {
    slot: "first"
  }, [_c('option', {
    attrs: {
      "disabled": "disabled"
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("-- Please select a Request Type --")])])], 2), _c('span', [_vm._v("Comment")]), _c('b-textarea', {
    attrs: {
      "id": "comment",
      "type": "text",
      "name": "comment",
      "rows": "3",
      "placeholder": "Enter Comment"
    },
    model: {
      value: (_vm.comment),
      callback: function($$v) {
        _vm.comment = $$v
      },
      expression: "comment"
    }
  }), _c('span', [_vm._v("User ID")]), _c('b-input', {
    attrs: {
      "id": "userID",
      "type": "text",
      "name": "userID",
      "placeholder": "Enter User ID",
      "disabled": "disabled"
    },
    model: {
      value: (_vm.userID),
      callback: function($$v) {
        _vm.userID = $$v
      },
      expression: "userID"
    }
  }), _c('span', [_vm._v("Email")]), _c('b-input', {
    attrs: {
      "id": "email",
      "type": "text",
      "name": "email",
      "placeholder": "Enter Email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _c('span', [_vm._v("Name")]), _c('b-textarea', {
    attrs: {
      "id": "name",
      "type": "text",
      "name": "name",
      "placeholder": "Enter Name"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _c('div', {
    slot: "modal-footer"
  }, [_c('b-button', {
    staticClass: "float-right ml-1",
    attrs: {
      "type": "button",
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.showPropt = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('b-button', {
    staticClass: "float-right ml-1",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.checkForm
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-0 px-3"
  }, [_c('h5', {
    staticClass: "mb-1",
    staticStyle: {
      "color": "#536c79"
    }
  }, [_vm._v("Media")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cba8baa4","hasScoped":true}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/fragments/interactionsRightbar.vue
// module id = 1584
// module chunks = 1